<script setup>
import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();
</script>

<template>
  <div class="flex items-center justify-between mt-6 relative">
    <div class="absolute w-full border top-2.5 border-white md:border-primary"/>

    <div 
      v-for="(step, index) in bookingStore.header_steps"
      class="flex flex-col items-center px-1 bg-primary z-20 relative md:bg-slate-100"
      @click="bookingStore.goBackToStep(step.name)"
      >
      <div 
        :class="[
          'rounded-full border border-white h-6 w-6 flex items-center justify-center font-bold text-sm md:border-primary',
          step.active ? 'bg-white text-primary md:bg-primary md:text-white' : 'md:text-primary'
        ]">
          {{ index+1 }}
        </div>
      <div class="text-xs mt-1">{{ step.label }}</div>
    </div>
  </div>
</template>